import React, { PropsWithChildren, useEffect, useRef } from "react";

import { KeyboardArrowLeft } from "@mui/icons-material";
import { Button, IconButton, Modal, Typography, useTheme } from "@mui/material";

import useEvent from "@/hooks/useEvent";

import { useFilterContext } from "../FilterContext";
import styles from "./FilterList.module.css";

function FilterPopperMobile(props: PropsWithChildren) {
  const { open, setOpen, fieldId, resetFilterData } = useFilterContext();

  const theme = useTheme();

  const scrollRef = useRef<HTMLDivElement>(null);

  const closeModal = useEvent(() => {
    setOpen(false);
  });

  useEffect(() => {
    const targetEl = document.getElementById(fieldId);
    if (open) {
      targetEl?.classList.add(styles.filterItemActive);
      scrollRef.current?.scrollTo({
        top: fieldId === "all" ? 0 : (targetEl?.offsetTop || 0) - 2,
      });
    } else {
      targetEl?.classList.remove(styles.filterItemActive);
    }
  }, [open, fieldId]);

  return (
    <Modal open={open} onClose={closeModal} keepMounted>
      <div
        className="w-[100%] h-[100%] flex flex-col"
        style={{
          backgroundColor: theme.palette.background.default,
        }}
      >
        <div className="w-[100%] flex-shrink-1 flex justify-center items-center py-[10px] px-[20px] relative">
          <IconButton onClick={closeModal} className="left-[10px] !absolute">
            <KeyboardArrowLeft />
          </IconButton>
          <Typography color="textPrimary" className="!text-[22px]">
            Filters
          </Typography>
        </div>
        <div className="relative flex-1 min-h-[1px] overflow-y-auto" ref={scrollRef}>
          {props.children}
        </div>
        <div className="flex-shrink-1 text-right py-[3px] px-[15px]">
          <Button variant="text" onClick={resetFilterData}>
            clear
          </Button>
          <Button variant="contained" onClick={closeModal}>
            Done
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default React.memo(FilterPopperMobile);
